import React from 'react';
import { Button } from '@ui';
import { Flex } from 'antd';
import { GUIDE_IMAGE_SRC } from './constants';
import { StyledModalImage } from './styled';

/**
 * Modal body: full guide screenshot with a Close button.
 * @param {object} props
 * @param {Function} props.close
 */
const GuidelineModal = ({ close }) => (
    <Flex vertical gap={24}>
        <StyledModalImage
            data-e2e='tracking_shopify_guide_modal_image'
            src={GUIDE_IMAGE_SRC}
            alt='Klickly orders in Shopify'
        />
        <Flex justify='flex-end'>
            <Button data-e2e='tracking_shopify_guide_modal_close_btn' type='primary' padding='0 58px' onClick={close}>
                Close
            </Button>
        </Flex>
    </Flex>
);

export default GuidelineModal;
